var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMobilePrepaid75D60071Ff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.26,
    cy: 22.05,
    r: 2.1,
    fill: "#1c54d6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6 11V9.54h-2.09V5.75A3.76 3.76 0 0 0 18.76 2h-9A3.75 3.75 0 0 0 6 5.75v18.5A3.75 3.75 0 0 0 9.76 28h9a3.76 3.76 0 0 0 3.75-3.75v-3.4l.61.5.95-1.16-3.49-2.84a4.68 4.68 0 0 0 2.16-1.14 3.69 3.69 0 0 0 1.08-2.07h.78v-1.5h-.85A3.9 3.9 0 0 0 23 11zm-2.41 1.6h-3.58v1.5h3.68a2.12 2.12 0 0 1-.59 1 4 4 0 0 1-3 .9l-.5 1.33 2.8 2.3v4.62a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25V5.75A2.25 2.25 0 0 1 9.76 3.5h9A2.25 2.25 0 0 1 21 5.75v3.79h-2.4V11h1.25 0a2.52 2.52 0 0 1 2.34 1.64z",
    fill: "#231f20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobilePrepaid75D60071Ff);
export default __webpack_public_path__ + "static/media/icon_mobile_Prepaid_75d60071ff.a19876fcb6d2c7fe8cbdaed1d22ebe6d.svg";
export { ForwardRef as ReactComponent };